import { h } from "../../core/dom.js";
import { latestEntry } from "../../dev/changelog.js";
import { buildRows } from "../../dev/localBuild.js";
import { changelogSheet } from "./changelogSheet.js";

export const devBadge = () => h("span", { class: "badge-dev" }, "Dev");

export function devPanel(app, onLock) {
  if (!app.devMode.enabled) return null;
  const rows = buildRows(app.config, {
    app: app.updates.app,
    model: app.updates.model,
    metadata: app.classifier.metadata
  });
  return h("div", { class: "dev-panel" },
    h("div", { class: "dev-list" }, rows.map(([key, value]) =>
      h("div", { class: "dev-row" }, h("span", { class: "dev-key" }, key), h("code", { class: "dev-value" }, value)))),
    h("div", { class: "detail-actions" },
      latestEntry() ? h("button", { class: "btn btn-secondary", type: "button",
        onclick: () => changelogSheet(app, latestEntry()) }, "Novità di questa versione") : null,
      h("a", { class: "btn btn-secondary", href: "#/dev" }, "Area sviluppatore"),
      h("button", { class: "btn btn-ghost", type: "button", onclick: onLock }, "Disattiva")));
}
